/**
 * Currency breakdown component showing payment distribution by currency.
 */

import { getCurrencySymbol } from "../../../../lib/format.ts";

interface CurrencyStats {
  currency: string;
  count: number;
  amount: string;
  percentage: number;
}

interface CurrencyBreakdownProps {
  data: CurrencyStats[];
}

const CURRENCY_COLORS: Record<string, string> = {
  THB: "bg-emerald-500",
  RUB: "bg-blue-500",
  USD: "bg-green-500",
  EUR: "bg-purple-500",
};

export function CurrencyBreakdown({ data }: CurrencyBreakdownProps) {
  if (data.length === 0) {
    return (
      <div className="card p-4">
        <p className="text-[12px] font-medium uppercase tracking-wide text-slate-400 mb-3">
          По валютам
        </p>
        <p className="text-[13px] text-slate-500 text-center py-4">
          Нет данных
        </p>
      </div>
    );
  }

  return (
    <div className="card p-4">
      <p className="text-[12px] font-medium uppercase tracking-wide text-slate-400 mb-3">
        По валютам
      </p>
      <div className="space-y-3">
        {data.map((item) => {
          const amount = parseFloat(item.amount);
          const barColor = CURRENCY_COLORS[item.currency] || "bg-slate-400";
          const symbol = getCurrencySymbol(item.currency);

          return (
            <div key={item.currency}>
              <div className="flex items-center justify-between mb-1">
                <span className="text-[13px] font-medium text-slate-700">
                  {item.currency} {symbol}
                </span>
                <span className="text-[13px] text-slate-600">
                  {amount.toLocaleString()} {symbol}
                </span>
              </div>
              <div className="flex items-center gap-2">
                <div className="flex-1 h-2 bg-slate-100 rounded-full overflow-hidden">
                  <div
                    className={`h-full ${barColor} rounded-full transition-all duration-300`}
                    style={{ width: `${Math.min(item.percentage, 100)}%` }}
                  />
                </div>
                <span className="text-[11px] text-slate-500 w-10 text-right">
                  {item.percentage.toFixed(0)}%
                </span>
              </div>
              <span className="text-[11px] text-slate-400">
                {item.count} заказов
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
